import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import './index.css'
import App from './App.jsx'
import ErrorBoundary from './components/ErrorBoundary.jsx'
// Initialize Sentry error tracking (only in production)
import './lib/sentry.js'

// Register service worker for PWA functionality when explicitly enabled for production
if (import.meta.env.PROD && import.meta.env.VITE_ENABLE_SW === 'true' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then(() => {
        // Service worker registered successfully (silent in production)
      })
      .catch(() => {
        // Service worker registration failed (silent in production)
      })
  })
}

const rootEl = document.getElementById('root')

// Global error handler for mount errors
window.__reactMountError = null;

if (!rootEl) {
  const error = new Error('Root element not found');
  window.__reactMountError = error;
  console.error(error)
} else {
  try {
    const root = createRoot(rootEl)
    root.render(
      <StrictMode>
        <ErrorBoundary>
          <HelmetProvider>
            <App />
          </HelmetProvider>
        </ErrorBoundary>
      </StrictMode>
    )
    // Mark root as mounted for fallback script
    rootEl.setAttribute('data-mounted', 'true')
    if (import.meta.env.DEV) console.log('React app mounted successfully')
  } catch (error) {
    window.__reactMountError = error;
    console.error('React mount failed:', error)

    // Provide detailed error info
    const errorDetails = {
      message: error.message,
      stack: error.stack,
      type: error.name,
      timestamp: new Date().toISOString()
    };

    // Store error details for progress indicator
    rootEl.setAttribute('data-mount-error', JSON.stringify(errorDetails));
  }
}

// Catch unhandled errors during initial load
window.addEventListener('error', (event) => {
  const root = document.getElementById('root');
  if (root && !root.getAttribute('data-mounted')) {
    window.__reactMountError = event.error || new Error(event.message);
    root.setAttribute('data-mount-error', JSON.stringify({
      message: event.message,
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
      type: 'RuntimeError',
      timestamp: new Date().toISOString()
    }));
  }
});